(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
if (!window.TestimonialSwiperLoaded) {
  const swiperScript = document.createElement('script');
  swiperScript.src = "https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js";
  document.body.appendChild(swiperScript);

  const swiperStyle = document.createElement('link');
  swiperStyle.rel = "stylesheet";
  swiperStyle.href = "https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.css";
  document.head.appendChild(swiperStyle);

  swiperScript.onload = function () {
    new Swiper(".testimonialSwiper", {
      slidesPerView: 2,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 }
      }
    });
  };

  window.TestimonialSwiperLoaded = true;
}

  } catch(e) { console.error(e); }
})();
})();
